import { Text, VStack } from '@chakra-ui/react'

const QAItem = ({ question, answer }: { question: string; answer: string }) => {
  return (
    <VStack
      data-aos="fade-up"
      w={{
        base: '100%',
        md: '90%'
      }}
      alignItems="flex-start"
      gap={1}
      mt={3}
    >
      <Text textStyle="oralcareQAQuestion">{question}</Text>

      <Text textStyle="docQAAnswer">{answer}</Text>
    </VStack>
  )
}

const QA = () => {
  return (
    <VStack py={10}>
      <Text
        data-aos="fade-up"
        w={{
          base: '100%',
          md: '90%'
        }}
        textStyle="oralcareQATitle"
        color={'#4b7438'}
        textAlign={'center'}
      >
        FREQUENTLY ASKED QUESTIONS
      </Text>
      <QAItem
        question="What is the difference between other mouthwashes compared to Health+ OralCare Mouthwash?"
        answer="Most mouthwashes contain alcohol contents, though it gives a refreshing feel, it might not fully remove plaque. Moreover, not everyone can withstand the aftertaste and sensation. With Health+ OralCare Mouthwash’s formula that does not contain alcohol and has a soothing taste of Korean red ginseng, any person above the age of 5 can use it with ease. The ingredients in the mouthwash also transform the plaque or any oil residues to become chunks of visible dirt when spit out after a good 30 seconds gargle.
        "
      />
      <QAItem
        question="Is Health+ OralCare Mouthwash safe to use?"
        answer="Yes, Health+ OralCare Mouthwash has been used for external medical supplies and has curative properties as well as it’s all natural ingredients."
      />
      <QAItem
        question="What are the benefits of mouthwash?"
        answer="It can reduce gingivitis, slow down the formation of tartar on your teeth, prevent tooth decay and freshen your breath."
      />
      <QAItem
        question="Which comes first?"
        answer="When it comes to the order of oral care, it doesn't matter whether you use a mouthwash before or after you brush and floss. Instead of focusing on what to pick up first when you're standing at the bathroom sink, simply make sure you're using the proper technique and doing a thorough job of all three."
      />
      <QAItem
        question="How long do I need to gargle for?"
        answer="It is usually best to keep the mouthwash in your mouth for at least 30 seconds and swish it thoroughly to ensure that it comes in contact with all of your teeth."
      />
      <QAItem
        question="How many times a day should I use?"
        answer="It can be used about 1-3 times according to need such as after food intake or before bedtime, before and after tooth brushing."
      />
      <QAItem
        question="Can kids use mouthwash?"
        answer="Yes, it is suitable for ages above 5 years."
      />
      <QAItem
        question="Can I use it during pregnancy?"
        answer="Yes, it may be used during pregnancy. If you experience vomiting, discomfort or any other abnormal symptoms in the teeth or mouth, stop using this product and consult with your dentist."
      />
      <QAItem
        question="Can sensitive teeth be used?"
        answer="It is recommended you get guidance from your dentist."
      />
      <QAItem
        question="How much usage do I need to use?"
        answer="It is recommended to consume it half cap per use. The cap has a standard usage line."
      />
      <QAItem
        question="What’s the efficacy of Ginseng flowers?"
        answer="Ginseng flowers contain more than five times the nutritive value. It’s the best ingredient to protect your teeth and prevent oral health problems."
      />
    </VStack>
  )
}
export default QA
